import {
  createActions,
  keyMirror,
  standardActions,
} from '@groove-labs/action-utils';

export const actionTypes = createActions({
  ACTION_COMPOSE: {
    ...keyMirror([
      'UPDATE_VISIBILITY',
      'TOGGLE_DESTRUCTION_CONFIRMATION',
      'TOGGLE_PREVIEW',
      'UPDATE_EXECUTION_CONTEXT_EDITABLE_FIELD',
      'SET_EXECUTION_CONTEXT',
      'RESET_CURRENT_EXECUTION_CONTEXT',
      'UPDATE_EXECUTION_CONTEXT_EDITABLE_FIELDS',
      'REMOVE_EXECUTION_CONTEXT',
      'SET_VIEW_MODE',
      'SET_ACTIVE_FOLDER',
      'RESET_TEMPLATES_STATE',
      'RESET_ACTIVE_DATA',
      'SET_ACTIVE_TEMPLATE',
      'SET_EMAIL_VARIANTS',
      'TOGGLE_TEMPLATES_VIEW_MODE',
      'SET_ORDER_OPTIONS',
      'UPDATE_VARIANT_TEMPLATE_BODY',
      'SET_EMAIL_ALIASES',
      'SET_DEFAULT_ALIAS',
      'FETCH_ACTION',
      'SET_ERROR_MESSAGE',
      'ACTION_CC_BCC_RECIPIENT_UPDATE',
      'REFRESH_PREVIEW',
    ]),
    FETCH_MESSAGE_HISTORY: standardActions(),
    FETCH_EXECUTION_CONTEXT: standardActions(),
    EXECUTE_ACTION: standardActions(),
    FETCH_SIGNATURE: standardActions(),
    EXECUTE_DESTRUCTION: standardActions(),
    CHECK_MERGE_FIELD_EXISTENCE: standardActions(),
    CHECK_GROOVE_TOKENS: standardActions(),
    FETCH_TEMPLATE_FOLDERS: standardActions(),
    FETCH_FOLDER_TEMPLATES: standardActions(),
    FETCH_TEMPLATE: standardActions(),
    FILTER_TEMPLATES: standardActions(),
    EXECUTE_TEMPLATE_ACTION: standardActions(),
    CC_SEARCH: standardActions(),
  },
}).ACTION_COMPOSE;

export const setOrderOptions = ({ key, orderBy, orderDir }) => ({
  type: actionTypes.SET_ORDER_OPTIONS,
  payload: {
    key,
    orderBy,
    orderDir,
  },
});

export const beginExecutingTemplateAction = ({ executionType }) => ({
  type: actionTypes.EXECUTE_TEMPLATE_ACTION.BEGIN,
  payload: { executionType },
});

export const failedExecutingTemplateAction = () => ({
  type: actionTypes.EXECUTE_TEMPLATE_ACTION.FAILURE,
});

export const setActiveFolder = ({ id }) => ({
  type: actionTypes.SET_ACTIVE_FOLDER,
  payload: { id },
});

export const setActiveTemplate = ({ id }) => ({
  type: actionTypes.SET_ACTIVE_TEMPLATE,
  payload: { id },
});

export const beginFetchingTemplate = () => ({
  type: actionTypes.FETCH_TEMPLATE.BEGIN,
});

export const successfullyFetchedTemplate = ({
  template,
  isFilterActive,
  hasVariants,
}) => ({
  type: actionTypes.FETCH_TEMPLATE.SUCCESS,
  payload: {
    template,
    isFilterActive,
    hasVariants,
  },
});

export const failedFetchingTemplate = () => ({
  type: actionTypes.FETCH_TEMPLATE.FAILURE,
});

export const beginFilteringTemplates = () => ({
  type: actionTypes.FILTER_TEMPLATES.BEGIN,
});

export const filteringTemplatesInProgress = () => ({
  type: actionTypes.FILTER_TEMPLATES.PROGRESS,
});

export const successfullyFilteredTemplates = ({ templates, orderedIds }) => ({
  type: actionTypes.FILTER_TEMPLATES.SUCCESS,
  payload: {
    templates,
    orderedIds,
  },
});

export const failedFilteringTemplates = () => ({
  type: actionTypes.FILTER_TEMPLATES.FAILURE,
});

export const beginFetchingTemplateFolders = () => ({
  type: actionTypes.FETCH_TEMPLATE_FOLDERS.BEGIN,
});

export const successfullyFetchedTemplateFolders = ({
  folders,
  orderedFolderIds,
}) => ({
  type: actionTypes.FETCH_TEMPLATE_FOLDERS.SUCCESS,
  payload: {
    folders,
    orderedFolderIds,
  },
});

export const failedFetchingTemplateFolders = () => ({
  type: actionTypes.FETCH_TEMPLATE_FOLDERS.FAILURE,
});

export const beginFetchingFolderTemplates = () => ({
  type: actionTypes.FETCH_FOLDER_TEMPLATES.BEGIN,
});

export const successfullyFetchedFolderTemplates = ({
  folderId,
  templates,
  orderedTemplateIds,
}) => ({
  type: actionTypes.FETCH_FOLDER_TEMPLATES.SUCCESS,
  payload: { folderId, templates, orderedTemplateIds },
});

export const failedFetchingFolderTemplates = () => ({
  type: actionTypes.FETCH_FOLDER_TEMPLATES.FAILURE,
});

export const updateVariantTemplateBody = ({ id, templateBody }) => ({
  type: actionTypes.UPDATE_VARIANT_TEMPLATE_BODY,
  payload: { id, templateBody },
});

export const setViewMode = ({ view }) => ({
  type: actionTypes.SET_VIEW_MODE,
  payload: { view },
});

export const toggleTemplatesViewMode = () => ({
  type: actionTypes.TOGGLE_TEMPLATES_VIEW_MODE,
});

export const resetActiveData = () => ({
  type: actionTypes.RESET_ACTIVE_DATA,
});

export const removeExecutionContext = ({ id }) => ({
  type: actionTypes.REMOVE_EXECUTION_CONTEXT,
  payload: { id },
});

export const beginCheckingGrooveTokens = () => ({
  type: actionTypes.CHECK_GROOVE_TOKENS.BEGIN,
});

export const successfullyCheckedGrooveTokens = () => ({
  type: actionTypes.CHECK_GROOVE_TOKENS.SUCCESS,
});

export const setExecutionContext = ({ actionId, executionContext }) => ({
  type: actionTypes.SET_EXECUTION_CONTEXT,
  payload: { actionId, executionContext },
});

export const resetExecutionContext = actionId => ({
  type: actionTypes.RESET_CURRENT_EXECUTION_CONTEXT,
  payload: { actionId },
});

export const beginCheckingMergeFieldExistence = ({ field, value }) => ({
  type: actionTypes.CHECK_MERGE_FIELD_EXISTENCE.BEGIN,
  payload: { field, value },
});

export const successfullyCheckedMergeFieldExistence = () => ({
  type: actionTypes.CHECK_MERGE_FIELD_EXISTENCE.SUCCESS,
});

export const togglePreview = () => ({
  type: actionTypes.TOGGLE_PREVIEW,
});

export const toggleDestructionConfirmation = ({ state }) => ({
  type: actionTypes.TOGGLE_DESTRUCTION_CONFIRMATION,
  payload: { state },
});

export const beginExecutingDestruction = ({ destructionType }) => ({
  type: actionTypes.EXECUTE_DESTRUCTION.BEGIN,
  payload: { destructionType },
});

export const successfullyExecutedDestruction = () => ({
  type: actionTypes.EXECUTE_DESTRUCTION.SUCCESS,
});

export const failedToExecuteDestruction = () => ({
  type: actionTypes.EXECUTE_DESTRUCTION.FAILURE,
});

export const beginFetchingExecutionContext = () => ({
  type: actionTypes.FETCH_EXECUTION_CONTEXT.BEGIN,
});

export const successfullyFetchedExecutionContext = () => ({
  type: actionTypes.FETCH_EXECUTION_CONTEXT.SUCCESS,
});

export const failedFetchingExecutionContext = () => ({
  type: actionTypes.FETCH_EXECUTION_CONTEXT.FAILURE,
});

export const beginExecutingAction = () => ({
  type: actionTypes.EXECUTE_ACTION.BEGIN,
});

export const failedExecutingAction = () => ({
  type: actionTypes.EXECUTE_ACTION.FAILURE,
});

export const successfullyExecutedAction = () => ({
  type: actionTypes.EXECUTE_ACTION.SUCCESS,
});

export const beginFetchingAction = () => ({
  type: actionTypes.FETCH_ACTION,
});

export const updateVisibility = ({ state }) => ({
  type: actionTypes.UPDATE_VISIBILITY,
  payload: { state },
});

export const updateExecutionContextEditableField = ({ field, value }) => ({
  type: actionTypes.UPDATE_EXECUTION_CONTEXT_EDITABLE_FIELD,
  payload: {
    field,
    value,
  },
});

export const updateExecutionContextEditableFields = ({ fields = [] }) => ({
  type: actionTypes.UPDATE_EXECUTION_CONTEXT_EDITABLE_FIELDS,
  payload: {
    fields,
  },
});

export const beginFetchingMessageHistory = () => ({
  type: actionTypes.FETCH_MESSAGE_HISTORY.BEGIN,
});

export const successfullyFetchedMessageHistory = ({ phone, history }) => ({
  type: actionTypes.FETCH_MESSAGE_HISTORY.SUCCESS,
  payload: { phone, history },
});

export const failedFetchingMessageHistory = () => ({
  type: actionTypes.FETCH_MESSAGE_HISTORY.FAILURE,
});

export const setEmailVariants = ({ templates, orderedIds }) => ({
  type: actionTypes.SET_EMAIL_VARIANTS,
  payload: { templates, orderedIds },
});

export function setEmailAliases(emailAliases) {
  return {
    type: actionTypes.SET_EMAIL_ALIASES,
    payload: emailAliases,
  };
}

export function setDefaultAlias(defaultAlias) {
  return {
    type: actionTypes.SET_DEFAULT_ALIAS,
    payload: defaultAlias,
  };
}

export const setErrorMessage = ({ message }) => ({
  type: actionTypes.SET_ERROR_MESSAGE,
  payload: { message },
});

export function updateActionCcRecipients({ email }) {
  return {
    type: actionTypes.ACTION_CC_BCC_RECIPIENT_UPDATE,
    payload: { recipients: email, recipientType: 'cc' },
  };
}

export function updateActionBccRecipients({ email }) {
  return {
    type: actionTypes.ACTION_CC_BCC_RECIPIENT_UPDATE,
    payload: { recipients: email, recipientType: 'bcc' },
  };
}

export function fetchCcPeople({ phrase }) {
  return {
    type: actionTypes.CC_SEARCH.BEGIN,
    payload: { phrase },
  };
}

export function refreshPreview() {
  return {
    type: actionTypes.REFRESH_PREVIEW,
  };
}
